module.exports = __webpack_public_path__ + "static/home-background-88eb133c2b6d9b71d464557bd3c8b7ba.jpg";